/**
 * config => 项目中常量配置
 * 
 * @param {String} baseUrl => 网络请求的域名
 * @param {String} timeout => 请求超时时间
 * 
*/

export default {
    //baseUrl: "http://127.0.0.1:5000",
    baseUrl: "http://yuyue.zzhxyy.com",
    timeout: 50000
}